import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const CouponViewModule = new Module({
  id: 'coupon-view',
  name: 'Coupon',
  path: 'coupon',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Coupon/View'))
  ),
  actions: {
    add: {
      id: 'add-coupon',
      name: 'add-coupon',
      label: 'Add Coupon'
    }
  }
});

export const CouponAddModule = new Module({
  id: 'coupon-add',
  name: 'couponAdd',
  path: 'coupon/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Coupon/Form'))
  ),
  actions: {
    add: {
      id: 'add-coupon-action',
      name: 'add-coupon-action',
      label: 'Add Coupon'
    }
  }
});

export const CouponEditModule = new Module({
  id: 'coupon-edit',
  name: 'CouponEdit',
  path: 'coupon/edit',
  pathDef: 'coupon/edit/:id',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Coupon/Form'))
  ),
  actions: {
    edit: {
      id: 'edit-coupon',
      name: 'edit-coupon',
      label: 'Edit'
    },
    delete: {
      id: 'delete-coupon',
      name: 'delete-coupon',
      label: 'Delete'
    }
  }
});

const CouponModules = [CouponViewModule, CouponAddModule, CouponEditModule];

export default new ModuleBundle('Coupon', CouponModules);
